import isEmail from 'validator/lib/isEmail';
import moment from "moment"
import crypto from "crypto";
const algorithm = "aes-256-cbc";
const secret = 'MyInpleo';

export const validateEmail = (email) => {
  return isEmail(email, { allow_display_name: false, require_display_name: false, allow_utf8_local_part: true, require_tld: true, allow_ip_domain: false, domain_specific_validation: false, blacklisted_chars: '' })
}


export const isEmpty = (obj) => (obj!==null || obj !== undefined) ? Object.keys(obj).length === 0 : null 

/**
 * @description function call to capital first letter each word
 * @param {String} item string
 * @returns string
 */
export const capitalizeFirstLetter = (item) => item?.toLowerCase().replace(/_/g, ' ')
  .replace(/(?: |\b)(\w)/g, function (key, p1) {
    return key.toUpperCase();
  })
export const removeUnderscore = (item) => {
   if(item){
    return item.replace(/_/g, ' ')
   }else {
     return
   }

} 
// export const trimSearchTag = (item) => item.replace('\n', ' ')


/**
  * @description method call for check overlap rectanges, x- axis, y- yxis, h height, w width
  * @param {*} r1 rectange xmlbounds
  * @param {*} r2 rectange jsonbounds
  * @returns boolean 
  */
export const intersectRect = (r1, r2) => {
  // console.log(r1,r2,((r2.x + r2.w) > r1.x && r2.x < r1.x + r1.w && r2.y + r2.h > r1.y && r2.y < r1.y + r1.h), "checking r1 and r2")
  return ((r2.x + r2.w) > r1.x && r2.x < r1.x + r1.w && r2.y + r2.h > r1.y && r2.y < r1.y + r1.h)
}

/**
 * @description function use to change date format 
 * @param {Date} date date string
 * @param {String} format accept date format 
 */
export const dateFormat = (date, format = 'MMMM Do YYYY, h:mm a') => moment(date).format(format)

// r2.x > r1.x && r2.x < (r1.x + r1.w)
/**
* @description method call to identify current rectange position exists
* @param {*} rect rectangle
* @param {*} x 
* @param {*} y 
* @param {*} k scale 
* @returns 
*/
export const hit = (rect, x, y, k) => (x >= rect.x && x <= rect.x + rect.w && y >= rect.y && y <= rect.y + rect.h)

/**
 * @description function use to find color bounds based on confidence vslued
 * if 0.9 less then yellow, 0.9 graterthen green, else red
 * @param {*} confidence  acceppting nimeric value
 * @returns  return string
 */
export const getBoundsColour = (confidence, cYellowRange, cRedRange) => {
  if (cRedRange?.start_range <= confidence && confidence <= cRedRange?.end_range) {
    return "red";
  }
  else if (cYellowRange?.start_range <= confidence && confidence <= cYellowRange?.end_range) {
    return "yellow";
  }
  else {
    return "green";
  }
}
/*export const getBoundsColour = (confidence) => {
  if (confidence > 0.9) {
    return "green";
  } else if (confidence > 0.8) {
    return "yellow";
  } else {
    return "red";
  }
}*/


export const toArrayBuffer = (buffer) => {
  const arrayBuffer = new ArrayBuffer(buffer.length);
  const view = new Uint8Array(arrayBuffer);
  for (let i = 0; i < buffer.length; ++i) {
    view[i] = buffer[i];
  }
  return arrayBuffer;
  }



/**
 * @description function use to load img elements
 * @param {*} src image path
 * @param {*} height image height
 * @param {*} width image width
 * @returns instance 
 */
export const addImageProcess = (src, height = 871, width = 673) => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.onload = () => resolve({ img: img, height: img.height, width: img.width })
    img.onerror = reject
    img.src = `data:image/*;base64,${src}`
  })
}

export const pdfProcess = (pdfdocument,pageNumber,scale ) => {
  return new Promise(async (resolve, reject) => {
    let page = await pdfdocument.getPage(parseInt(pageNumber));
    let viewport = await page.getViewport({ scale: scale });
    resolve(viewport)
  })
}


export const addGaps = (str) => str.replace(/\s?/g, '').replace(/(\d{4})/g, '$1 ').trim()

export const addSlash = (expdate) => expdate.replace(/\//g, "").substring(0, 2) +
  (expdate.length > 2 ? '/' : '') +
  expdate.replace(/\//g, "").substring(2, 4);
/**
  * Encrypts text
  * @param {string} text - text to encrypt
  */
export const encrypt = (text) => {
  const cipher = crypto.createCipher(algorithm, secret);
  let crypted = cipher.update(text, "utf8", "hex");
  crypted += cipher.final("hex");
  return crypted;
}

export const getDefaultScale = (val) => {
  if (val < 800) {
    return 1
  }
  else if (val < 1100) {
    return .8
  } else if (val < 1500) {
    return 1.1;
  } else if (val < 1700) {
    return 1.3;
  } else if (val < 1800) {
    return 1.5;
  } else if (val < 2000) {
    return 2.0;
  } else if (val < 2500) {
    return 2.5;
  } else if (val < 3000) {
    return 3.0;
  } else {
    return 4.0;
  }
}


export const convertToCSV = (objArray) => {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';
  for (var i = 0; i < array.length; i++) {
    var line = '';
    for (var index in array[i]) {
      if (line != '') line += ','

      line += array[i][index];
    }

    str += line + '\r\n';
  }
  return str;
}

export const exportCSVFile = (headers, items, fileTitle) => {

  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);
  var csv = convertToCSV(jsonObject);
  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export const camelCase = (str) => {
  return (str.slice(0, 1).toUpperCase() + str.slice(1))
    .replace(/([-_ ]){1,}/g, ' ')
    .split(/[-_ ]/)
    .reduce((cur, acc) => {
      return cur + " " + acc && acc[0] && acc[0].toUpperCase() + acc && acc.substring(1);
    });
}


export const arrayToString = (arr) => {
  return arr.join(", ");
}


export const isValEmpty = (val) => {
  return (val === undefined || val === null || val === '') ? true : false;
}



// export const cardImgs = (cardType) => {
//   let imageUrl;
//   switch (cardType) {
//     case "visa":
//       imageUrl = require(`../../../assets/img/payment/card-logo-visa.svg`);
//       break;
//     case "mastercard":
//       imageUrl =  require(`../../../assets/img/payment/card-logo-mastercard.svg`);
//       break;
//     case "american-express":
//       imageUrl = require(`../../../assets/img/payment/card-logo-amex.svg`);
//       break;
//     default:
//       imageUrl = require(`../../../assets/img/payment/card-logo-unknown.svg`);
//   }
//   return imageUrl;
// }

export function debounce(func, timeout = 1000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export const formatValue = (value) => {
  // remove leading/trailing whitespace and newlines
  value = value.trim().replace(/[\r\n]+/g, '');

  // split on underscores and capitalize each word
  let words = value.split('_');
  words = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

  // join the words and return
  return words.join('');
}